import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

interface FlowStepsProps {
  /** Paso activo: 1 = configurar, 2 = simular, 3 = resultados. */
  current: 1 | 2 | 3;
}

/** Indicador de progreso de los flujos MVP (configurar → simular → resultados). */
export default function FlowSteps({ current }: FlowStepsProps) {
  const { t } = useTranslation();
  const steps = [
    t('mvpFlow.stepConfigure'),
    t('mvpFlow.stepSimulate'),
    t('mvpFlow.stepResults'),
  ];

  return (
    <ol className="mb-8 flex items-center gap-2 sm:gap-3">
      {steps.map((label, i) => {
        const n = i + 1;
        const active = n === current;
        const done = n < current;
        const highlighted = active || done;
        return (
          <li key={label} className="flex items-center gap-2 sm:gap-3">
            {i > 0 && (
              <span
                className={`h-px w-5 transition-colors sm:w-10 ${
                  highlighted ? 'bg-primary/40' : 'bg-border'
                }`}
                aria-hidden
              />
            )}
            <span
              className={`flex items-center gap-2 rounded-full px-2.5 py-1.5 text-xs font-medium transition-colors sm:px-3 sm:text-sm ${
                active
                  ? 'bg-primary/10 text-primary'
                  : done
                    ? 'text-foreground'
                    : 'text-muted-foreground'
              }`}
            >
              <span
                className={`flex size-5 items-center justify-center rounded-full text-[11px] font-semibold transition-colors ${
                  highlighted ? 'text-white' : 'bg-muted text-muted-foreground'
                }`}
                style={highlighted ? { background: 'var(--gradient-agencium)' } : undefined}
              >
                {done ? <Check className="size-3" /> : n}
              </span>
              {label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
